export default "__VITE_ASSET__DM5uM4Z$__"